import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";

export default function getPairedAmenityGroupType(pairedAmenityGroups: PairedSingleAndReturnAmenitiesType) {
    return pairedAmenityGroups.singleGroup?.type ?? pairedAmenityGroups.returnGroup?.type
}